<template>
  <div class="flex grow flex-col overflow-y-auto bg-basec dark:bg-basec-dark">
    <div class="flex shrink-0 items-center justify-center lg:sticky top-0 bg-basec dark:bg-basec-dark py-6">
      <RouterLink to="/">
        <img
          class="h-24 max-w-48 w-full object-contain"
          :src="darkMode && hub.logo_dark_url ? hub.logo_dark_url : hub.logo_url"
          :alt="hub.name" />
      </RouterLink>
    </div>
    <component v-if="hub.sidebar_module" :is="hub.sidebar_module" />
    <nav class="flex flex-1 flex-col p-6 pt-0">
      <ul role="list" class="flex flex-1 flex-col gap-y-7">
        <li>
          <ul role="list" class="-mx-2 space-y-1">
            <NtNavigationSidebarItem v-for="item in items" :key="item.id" :item="item" />
          </ul>
        </li>
        <li class="mt-auto" v-if="$can('access members hub admin')">
          <ul role="list" class="-mx-2 space-y-1">
            <NtNavigationSidebarItem
              v-if="sentryFeedbackEnabled"
              :item="{
                is_external: true,
                id: 'sentryFeedback',
                name: 'Send Feedback',
                icon: 'fa-bullhorn',
                is_published: true
              }" />
            <NtNavigationSidebarItem :item="{ path: 'admin', name: 'Admin', icon: 'fa-wrench', is_published: true }" />
          </ul>
        </li>
      </ul>
    </nav>
  </div>
</template>

<script>
import { useSystemStore } from '@/stores/system'
import { mapState } from 'pinia'
import NtNavigationSidebarItem from './NtNavigationSidebarItem.vue'
import { useAuthStore } from '@/stores/auth'

export default {
  components: {
    NtNavigationSidebarItem
  },
  computed: {
    ...mapState(useSystemStore, ['hub', 'routes', 'previousRoute', 'darkMode']),
    ...mapState(useAuthStore, ['selectedOffice']),
    sentryFeedbackEnabled() {
      return import.meta.env.VITE_SENTRY_FEEDBACK_ENABLED === 'true'
    },
    items() {
      return this.routes.filter(
        (route) =>
          route.parent_id === null &&
          !route.modules.find((m) => m.model !== null) &&
          (!this.hub.country_filters_enabled ||
            (this.hub.country_filters_enabled &&
              (route.country_visibility.length === 0 ||
                route.country_visibility.includes(this.selectedOffice.country))))
      )
    }
  }
}
</script>
